// extracted by mini-css-extract-plugin
module.exports = {"root":"TransactionEntry_root__2J4f-"};